import view from "../../views/privacy.js";
import KTAPI from "../api/index.api.js";
import { KTLang } from "../lang/lang.js";
let about = {
    render: () => {
        return view;
    },
    after_render: async () => {
        KTLang.update();
        
    },
    root: false, 
    rerender: true,
    where: '#kt_content'
};

export default about;